// ===========================================================================
// Clinical Note — Template Confirm (modulo TEMPORAL)
//
// Pantalla de revision: un tab por cada template real de nota clinica de
// AdvancedMD, con la nota completa dibujada campo por campo tal como la
// dibuja el CDCI. Sirve para que el equipo clinico confirme la estructura
// (campos, tipos de control y distribucion por seccion) antes de darla por
// buena en produccion.
// ===========================================================================

export const TEMPLATE_CONFIRM_BASE_PATH = "/clinical-note-template-confirm";
